import React from "react";

const TextArea = React.forwardRef((props, ref) => (
	<React.Fragment>
		{(props.labelText || props.label) && (
			<label className="form__label">
				{props.labelText || props.label}
				{props.requiredStar ? (
					<span
						style={{ color: "#ff0505", paddingLeft: "1px", opacity: "0.7" }}
					>
						*
					</span>
				) : (
					""
				)}
			</label>
		)}
		<div
			style={{ position: "relative", width: props.width ? props.width : "" }}
		>
			<textarea
				className="form__input"
				value={props.value}
				name={props.name}
				maxLength={props.maxLength ? props.maxLength : ""}
				placeholder={props.placeholder}
				onChange={props.changeInput || props.inputChange || props.onChange}
				required={props.required}
				disabled={props.disabled}
				rows={props.rows}
				columns={props.columns}
				autoComplete={props.autoComplete}
				{...(props.inputKeyPress && { onKeyPress: props.inputKeyPress })}
				style={{
					padding: "9px 12px",
					marginBottom: props.withMargin ? "20px" : "",
					paddingLeft: props.withIcon ? "35px" : props.currency ? "25px" : "",
					border: props.errorText ? "1px solid red" : "",
				}}
				ref={ref}
			/>
			{props.icon && (
				<span
					className="input-icon flex"
					style={{
						position: "absolute",
						transform: "translateY(-50%)",
						top: "50%",
						paddingLeft: "10px",
					}}
				>
					{props.icon}
				</span>
			)}

			{props.errorText && (
				<span
					style={{
						position: "absolute",
						fontSize: "11px",
						color: "red",
						bottom: "-17px",
					}}
				>
					{props.errorText}
				</span>
			)}
			{props.countLength && props.maxLength && (
				<span
					style={{
						position: "absolute",
						fontSize: "9px",
						color: "#5e7079",
						bottom: "-14px",
						right: "0px",
					}}
				>
					{props.value.length} / {props.maxLength}
				</span>
			)}
		</div>
	</React.Fragment>
));

export default TextArea;
